import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';


export interface ProductSubCategoryMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}
export interface ProductSubCategoryMst {
    id?:number;
    name:string;  
 
    createdBy:number;
    createdDate:Date;
    updatedBy:number;
    updatedDate:Date
    tenantId:any;
    branchId:any;
      
    parameters?: ProductSubCategoryMstParameter[];
    links?: any;
}

export abstract class ProductSubCategoryMstData { 
    abstract list(url: string): Observable<ProductSubCategoryMst[]>;
    abstract create(url: string,data: ProductSubCategoryMst): Observable<any>;
    abstract update(url: string,data: ProductSubCategoryMst): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
